<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>系统参数</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>系统参数配置</span>
        </div>
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :status-icon="true"
          @submit.native.prevent="submitForm('form')"
        >
          <el-alert type="warning" :closable="true">
            <b>系统参数配置，影响系统运行和结算，请谨慎操作！</b>
          </el-alert>
          <br />

          <el-form-item label="系统名称" prop="sysName" :rules="[{required:true,message:'请输入系统名称'}]">
            <el-input v-model="form.sysName" placeholder="请输入系统名称"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="company" :rules="[{required:true,message:'请输入公司名称'}]">
            <el-input v-model="form.company" placeholder="请输入公司名称"></el-input>
          </el-form-item>
          <el-divider content-position="left">管理员</el-divider>
           <el-form-item label="邮箱" prop="email" :rules="[{required:true,message:'请输入邮箱'},{type:'email',message:'邮箱格式不正确'}]">
            <el-input v-model="form.email" placeholder="请输入公司名称"></el-input>
          </el-form-item>
           <el-form-item label="手机号" prop="mobile" :rules="[]">
            <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
          </el-form-item>
          <el-form-item label="QQ" prop="mobile" :rules="[]">
            <el-input v-model="form.qq" placeholder="请输入QQ号"></el-input>
          </el-form-item>
          <el-form-item label="咨询地址" prop="onlineLinkUrl" :rules="[]">
            <el-input v-model="form.onlineLinkUrl" placeholder="请输入在线咨询地址"></el-input>
          </el-form-item>
          <!-- <el-form-item
            label="骑手佣金"
            prop="riderAmount"
            :rules="[{required:true,message:'不能为空'},{type:'number',message:'请填写数字'}]"
          >
            <el-input v-model.number="form.riderAmount" placeholder="请输入佣金"></el-input>
          </el-form-item>

          <el-form-item
            label="配送费"
            prop="distFee"
            :rules="[{required:true,message:'不能为空'},{type:'number',message:'请填写数字'}]"
          >
            <el-input v-model.number="form.distFee" placeholder="请输入配送费">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item
            label="结算费率"
            prop="poundage"
            :rules="[{required:true,message:'不能为空'},{type:'number',message:'请填写数字'}]"
          >
            <el-input v-model.number="form.poundage" placeholder="请输入结算费率值"></el-input>
          </el-form-item>
          -->
           <!-- 地址 -->
          <el-form-item label="地址" prop="siteDetail" :rules="[]">
            <el-input v-model="form.siteDetail" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-row :gutter="24">
            <el-col :span="10">
              <el-form-item
                label="经度"
                prop="siteLongitude"
                :rules="[{required:false,message:'请选择坐标',trigger:'blur'},{required:true,message:'不能为空'}]"
              >
                <el-input v-model="form.siteLongitude"></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="10">
              <el-form-item
                label="纬度"
                prop="siteLatitude"
                :rules="[{required:false,message:'请选择坐标',trigger:'blur'},{required:true,message:'不能为空'}]"
              >
                <el-input v-model="form.siteLatitude"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="success" @click="dialogMap=true;">选择位置</el-button>
            </el-col>
          </el-row>
          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit">提交</el-button>
            <!-- <el-button @click="dialogVisible=false">取消</el-button> -->
          </el-form-item>
        </el-form>
      </el-card>
    </div>
    <!-- 地图选择管理 -->
    <el-dialog title="地址选择" :visible.sync="dialogMap" @opened="dialogMapOpen();">
      <el-form label-width="100px">
        <el-form-item label="搜索地址：">
          <el-input v-model="searchKey">
            <el-button type="primary" slot="append" icon="el-icon-search" @click="searchMap">搜索</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <div id="mapContainer" style="height:500px;"></div>
      <div class="dialog-footer" slot="footer">
        <el-button type="success" @click="yesClickMap">确定</el-button>
        <el-button @click="dialogMap=false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      submiting: false,
      form: {} ,//参数对象
      dialogMap: false,
      searchKey: ""
    };
  },
  methods: {
    //获取配置信息
    getConfig: function() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      var link = url.getSys("getconfig");
      $.get(link, params, data => {
        _this.loading = false;
        _this.form = data;
      });
    },

    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getSys("saveconfig");
      var info = this.form;
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submiting = true;
          //添加或者修改
          $.post(link, info, res => {
            _this.submiting = false;
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        } else {
          return false;
        }
      });
    },
        //地图框显示
    dialogMapOpen() {
      var _this = this;
      // 选择坐标处理
      var map;
      var marker;
      var citylocation;
      var siteLatitude = _this.form.siteLatitude;
      if (!siteLatitude) siteLatitude = 39.916527;
      var siteLongitude = _this.form.siteLongitude;
      if (!siteLongitude) siteLongitude = 116.397128;
      var init = function() {
        var center = new qq.maps.LatLng(siteLatitude, siteLongitude);
        map = new qq.maps.Map(document.getElementById("mapContainer"), {
          center: center,
          zoom: 13
        });
        //获取城市列表接口设置中心点
        citylocation = new qq.maps.CityService({
          complete: function(result) {
            var startLatLng = result.detail.latLng;
            if (_this.form.latitude) {
              startLatLng = new qq.maps.LatLng(
                _this.form.latitude,
                _this.form.longitude
              );
            }
            map.setCenter(startLatLng);
            _this.latLng = startLatLng;

            //添加标记
            marker = new qq.maps.Marker({
              position: startLatLng,
              draggable: true,
              map: map
            });
            _this.marker = marker;
            //添加到提示窗
            var info = new qq.maps.InfoWindow({
              map: map
            });
            qq.maps.event.addListener(marker, "mouseup", function(e) {
              //获取经纬度 e.latLng
              //获取坐标 e.cursorPixel
              info.open();
              info.setContent(
                '<div style="text-align:center;white-space:nowrap;' +
                  'margin:10px;">坐标：' +
                  e.latLng.lat +
                  "," +
                  e.latLng.lng +
                  "</div>"
              );
              info.setPosition(e.latLng);

              _this.latLng = e.latLng;
            });
          }
        });
        //调用searchLocalCity();方法    根据用户IP查询城市信息。
        citylocation.searchLocalCity();

        //处理搜索逻辑
        _this.map = map;
        _this.searchKey = _this.form.siteDetail;
        if (!_this.form.latitude && _this.searchKey) {
          setTimeout(() => {
            _this.searchMap();
          }, 500);
        }
      };
      init();
    },
    //确定按钮
    yesClickMap() {
      this.form.siteLatitude = this.latLng.lat;
      this.form.siteLongitude = this.latLng.lng;
      this.dialogMap = false;
    },
    //搜索按钮
    searchMap() {
      var _this = this;
      //执行搜索操作
      var searchService = new qq.maps.SearchService({
        complete: function(results) {
          var res = results.detail;
          if (res.pois && res.pois.length > 0) {
            var latLng = res.pois[0].latLng;
            _this.map.setCenter(latLng);
            _this.marker.setPosition(latLng);
          }
        }
      });
      searchService.search(this.searchKey);
    }
  },
  mounted() {
    //获取服务器列表
    this.getConfig();
  }
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
